import styled from "@emotion/styled";

export const TableCardTop = styled.div`
    margin: 2rem auto;
    width: 100%;
    max-width: 1400px;
`;

export const BackButtons = styled.button<{
    backgroundColorHex?: string;
}>`
    width: 170px;
    text-transform: capitalize;
    padding: 0.55rem 1.125rem;
    border-radius: 0.375rem;
    font-size: 0.9em;
    font-weight: 600;
    color: rgb(255, 255, 255);
    background-color: ${(props) => props.backgroundColorHex ?? "rgb(22 59 93)"};
    text-decoration: none;
    font-family: Helvetica, Arial, sans-serif;
    border: navajowhite;
    cursor: pointer;
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: center;
`;

export const ButtonText = styled.span``;
